var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgArrowheadDown = function SvgArrowheadDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9.6,
    height: 4.8
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.316 1.274A.652.652 0 009.391.258l-.064-.06a.746.746 0 00-.92-.072l-3.63 2.968L1.194.126a.746.746 0 00-.921.072l-.064.06a.651.651 0 00.075 1.016l4.062 3.39a.748.748 0 00.862 0z",
    fill: "#fff"
  })));
};
export default SvgArrowheadDown;